var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleConsentMode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App Icon",
    clipPath: "url(#clip0_3996_99979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google_gsuite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.9998 18.3987C35.9998 16.9187 35.8773 15.8387 35.6121 14.7188H18.3672V21.3987H28.4896C28.2856 23.0587 27.1835 25.5587 24.7345 27.2386L24.7002 27.4623L30.1527 31.6018L30.5304 31.6388C33.9998 28.4987 35.9998 23.8787 35.9998 18.3987Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3672 36.0025C23.3263 36.0025 27.4895 34.4024 30.5304 31.6425L24.7345 27.2424C23.1835 28.3024 21.1018 29.0424 18.3672 29.0424C13.5101 29.0424 9.38767 25.9025 7.91814 21.5625L7.70274 21.5804L2.03313 25.8804L1.95898 26.0824C4.97936 31.9624 11.1835 36.0025 18.3672 36.0025Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.91829 21.5636C7.53054 20.4436 7.30614 19.2435 7.30614 18.0036C7.30614 16.7635 7.53054 15.5635 7.89789 14.4436L7.88762 14.205L2.14696 9.83594L1.95914 9.92349C0.714294 12.3635 0 15.1036 0 18.0036C0 20.9036 0.714294 23.6435 1.95914 26.0835L7.91829 21.5636Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3672 6.95995C21.8161 6.95995 24.1426 8.41995 25.4692 9.64003L30.6528 4.68C27.4693 1.78001 23.3263 0 18.3672 0C11.1835 0 4.97936 4.03997 1.95898 9.91992L7.89774 14.44C9.38767 10.1 13.5101 6.95995 18.3672 6.95995Z",
    fill: "#EB4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3996_99979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleConsentMode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-consent-mode.4da580a9ce37ec247a5fe490a7d84604.svg";